import { Expose } from 'class-transformer'

export default class AdminConfiguration {
  @Expose({ name: 'tenant_currency' })
  public tenantCurrency!: string
}
